import { createFileRoute } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { Picture } from "@/components/Picture";
import { StickyNav } from "@/components/StickyNav";
import { ButtonAnchor } from "@/components/ui/button";
import { Anchor, Link } from "@/components/ui/typography";
/* eslint-disable import-x/no-duplicates */
// @ts-expect-error TODO: fix this
import heroIllustration from "@/images/illustration.png?slice=1&height=1200&width=1200&x=600&y=931";
// @ts-expect-error TODO: fix this
import card3 from "@/images/illustration.png?slice=1&height=221&width=306&x=1611&y=197";
// @ts-expect-error TODO: fix this
import card2 from "@/images/illustration.png?slice=1&height=221&width=396&x=789&y=4921";
// @ts-expect-error TODO: fix this
import card1 from "@/images/illustration.png?slice=1&height=321&width=306&x=1546&y=1837";
/* eslint-enable import-x/no-duplicates */
import sparkImg from "@/images/spark.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";
import tinyFooterFlower from "@/images/tiny-footer-flower.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";

export const Route = createFileRoute("/developers")({
  component: RouteComponent,
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Developers | Graze",
      description:
        "Build apps for ATProto without without worrying about the hard parts.",
      ogTitle: "Developers | Graze",
      pathname,
      ogImage: "/developers.png",
    }),
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-slate-app instrument-sans text-slate-normal">
      <header className="bg-slate-10 dark:bg-slatedark-10 text-slate-contrast dark:text-slatedark-contrast">
        <div className="flex items-center gap-12 mx-auto container px-4">
          <div className="h-full items-center justify-center hidden md:flex flex-1 @container">
            <div className="relative flex items-center justify-center">
              <div
                className="sharp-grotesk text-[100cqw] leading-[0.9] big-g-scroll"
                style={{
                  backgroundImage: `url('${heroIllustration}')`,
                  backgroundSize: "100cqw",
                  backgroundClip: "text",
                  color: "transparent",
                  textShadow: "none",
                }}
              >
                G
              </div>
              <div className="absolute right-[4.5cqw] bottom-[8cqw] text-slate-12 font-mono text-[10.5cqw]">
                Graze
              </div>
            </div>
          </div>
          <div className="flex-1 py-6 md:py-10 flex flex-col @container">
            <div className="flex mb-2 md:mb-16 md:justify-end sticky top-[-100%]">
              <MarketingNavBar onlyNav variant="light" />
            </div>
            <h1 className="text-[14cqw] instrument-serif bold mb-8 leading-none">
              Build the Future of Social with Graze
            </h1>
            <div className="mb-6 md:mb-8 flex flex-col gap-4 max-w-[68ch] border-2 border-slate-11 dark:border-slatedark-11 rounded-xl p-4 bg-white/30 dark:bg-black/30">
              <p className="text-xl md:text-2xl font-medium">
                Build apps for ATProto without without worrying about the hard
                parts.
              </p>
            </div>
          </div>
        </div>
      </header>

      <StickyNav variant="slate" />

      <section className="py-6 md:py-16">
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            Everything you need to build
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card1}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Contrails
                </div>
                <div className="text-lg">
                  Jetstream got you winded? Use{" "}
                  <Link to="/docs/$slug" params={{ slug: "contrails" }}>
                    contrails
                  </Link>{" "}
                  to consume a Graze feed as a real-time stream and get only the
                  content you care about.
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card2}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  ATProto Authentication
                </div>
                <div className="text-lg">
                  Don't worry about decentralized authentication. We've got you
                  covered with our{" "}
                  <Anchor href="https://github.com/graze-social/aip">
                    AIP
                  </Anchor>
                  implementation.
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card3}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Event Automation
                </div>
                <div className="text-lg">
                  Want to run automations based on events in the jetstream? Try
                  out
                  <Anchor href="https://github.com/graze-social/iftta">
                    If This Then AT
                  </Anchor>
                  ! You can even connect it to Zapier.
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed text-center mx-auto">
            Not enough? We've even open sourced{" "}
            <Anchor href="https://github.com/graze-social/grazer">
              our entire backend
            </Anchor>{" "}
            so you could run your feed on your own infrastructure.
          </p>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-slate-3 dark:bg-slatedark-3">
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            Success stories from the ecosystem
          </h2>
          <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
            <div className="flex-1 flex flex-col gap-10">
              <p className="text-xl md:text-3xl max-w-[68ch] leading-relaxed">
                Skylight solved a make-or-break problem by implementing Graze's
                curated feeds, transforming their platform and putting quality
                content at the core of their user experience.
              </p>
              <div className="flex items-center gap-2 md:gap-4">
                <div className="text-lg font-semibold p-4 border-2 border-green-7 dark:border-greendark-7 rounded-lg bg-green-3 dark:bg-greendark-3 text-green-normal">
                  67% increase in user retention
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-4 shrink-0 flex-1">
              <div className="shrink-0 md:flex-1 flex items-center bg-teal-10 dark:bg-tealdark-10 text-teal-contrast dark:text-tealdark-contrast @ border-2 border-teal-11 dark:border-tealdark-11 rounded-lg @container">
                <div className="p-8 flex flex-col items-end gap-8">
                  <div className="flex items-center md:items-start gap-8">
                    <div className="shrink-0 h-[100px] w-[100px]">
                      <img
                        src="https://cdn.bsky.app/img/avatar/plain/did:plc:4adlzwqtkv4dirxjwq4c3tlm/bafkreibcmt5pb6t2rf445ccashnjbzekxglfshjru3hjw5z3b26zd45kau@jpeg"
                        alt=""
                        className="h-full w-full rounded-full border-2"
                      />
                    </div>
                    <div className="text-lg md:text-xl leading-relaxed">
                      After implementing Graze Social's custom feeds, we saw a
                      67% increase in DAU on Skylight. We're now making Graze's
                      custom feeds the core of our FYP, letting our 220K+ users
                      swipe through, follow, and create their own. This wouldn't
                      have been possible without Graze's work.
                    </div>
                  </div>
                  <div className="text-lg md:text-xl instrument-serif">
                    ~ Tori White, CEO,{" "}
                    <a
                      href="https://sill.social/"
                      className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                    >
                      Skylight Social
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-yellow-slate-3 dark:bg-yellow-slatedark-3 relative">
        <div className="container mx-auto p-4 md:px-12 flex flex-col md:flex-row gap-8 md:gap-16">
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-2">
              <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
                Graze Grants
              </h2>
              <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed text-slate-dim">
                Investing in ecosystem builders
              </p>
            </div>
            <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed">
              We're backing the developers, creators, and communities shaping
              the future of decentralized social. Our grant program provides
              unrestricted funding to accelerate innovation in the ATProto
              ecosystem.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg md:text-xl">
              <li>
                <div className="h-full flex flex-col gap-4 border-2 border-teal-7 dark:border-tealdark-7 rounded-lg p-4 bg-teal-3 dark:bg-tealdark-3 text-teal-normal">
                  <div className="flex flex-col gap-1">
                    <div className="font-semibold text-xl md:text-2xl text-teal-dim">
                      SkyShrooms
                    </div>
                    <div className="text-slate-dim">
                      by{" "}
                      <Anchor href="https://bsky.app/profile/did:plc:hsqwcidfez66lwm3gxhfv5in">
                        business goose
                      </Anchor>
                    </div>
                  </div>
                  <div>
                    A whimsical mushroom-themed trading card game with
                    extensible systems for community-created content and
                    gameplay.
                  </div>
                </div>
              </li>
              <li>
                <div className="h-full flex flex-col gap-4 border-2 border-pink-7 dark:border-pinkdark-7 rounded-lg p-4 bg-pink-3 dark:bg-pinkdark-3">
                  <div className="flex flex-col gap-1">
                    <div className="font-semibold text-xl md:text-2xl text-pink-dim">
                      Tomo
                    </div>
                    <div className="text-slate-dim">
                      by{" "}
                      <Anchor href="https://bsky.app/profile/essentialrandom.bsky.social">
                        Ms Boba
                      </Anchor>
                    </div>
                  </div>
                  <div>
                    An old-school guestbook reimagined for the decentralized
                    web, doubling as an educational reference app for ATProto
                    development.
                  </div>
                </div>
              </li>
              <li>
                <div className="h-full flex flex-col gap-4 border-2 border-blue-7 dark:border-bluedark-7 rounded-lg p-4 bg-blue-3 dark:bg-bluedark-3">
                  <div className="flex flex-col gap-1">
                    <div className="font-semibold text-xl md:text-2xl text-blue-dim">
                      Party Starter
                    </div>
                    <div className="text-slate-dim">
                      by{" "}
                      <Anchor href="https://bsky.app/profile/partystarter.bsky.social">
                        by @partystarter.bsky.social
                      </Anchor>
                    </div>
                  </div>
                  <div>
                    Location-aware event toolkit for spontaneous gatherings,
                    bringing new energy to museums, workshops, and research
                    communities.
                  </div>
                </div>
              </li>
              <li>
                <div className="h-full flex flex-col gap-4 border-2 border-green-7 dark:border-greendark-7 rounded-lg p-4 bg-green-3 dark:bg-greendark-3">
                  <div className="flex flex-col gap-1">
                    <div className="font-semibold text-xl md:text-2xl text-green-dim">
                      Receipt Sky
                    </div>
                    <div className="text-slate-dim">
                      by{" "}
                      <Anchor href="https://bsky.app/profile/fjpaz.net">
                        @fjpaz.net
                      </Anchor>
                    </div>
                  </div>
                  <div>
                    Physical-digital bridge using thermal printers to turn
                    Bluesky posts into tangible, shareable artifacts.
                  </div>
                </div>
              </li>
              <li>
                <div className="h-full flex flex-col gap-4 border-2 border-orange-7 dark:border-orangedark-7 rounded-lg p-4 bg-orange-3 dark:bg-orangedark-3">
                  <div className="flex flex-col gap-1">
                    <div className="font-semibold text-xl md:text-2xl text-orange-dim">
                      Weaver
                    </div>
                    <div className="text-slate-dim">
                      by{" "}
                      <Anchor href="https://bsky.app/profile/nonbinary.computer">
                        @nonbinary.computer
                      </Anchor>
                    </div>
                  </div>
                  <div>
                    Flexible writing and publishing platform for long-form
                    content, built for creators who want control over their work
                    and audience.
                  </div>
                </div>
              </li>
              <li className="flex items-center justify-center">
                <div className="w-[24px] md:w-[25%]">
                  <Picture src={tinyFooterFlower} alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-slate-9 dark:bg-slatedark-9 text-slate-contrast dark:text-slatedark-contrast relative">
        <div className="absolute top-2 md:top-6 xl:top-12 left-6 flex items-center justify-center w-[80px] md:w-[10%] z-0">
          <Picture src={sparkImg} alt="" />
        </div>
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-12 relative z-1">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif text-center text-shadow-lg md: max-w-[60vw] mx-auto leading-tight">
            Ready to build?
          </h2>
          <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed mx-auto">
            Start with our developer tools and join the community shaping
            decentralized social.
          </p>
          <div className="flex gap-4 justify-center">
            <ButtonAnchor href="https://discord.gg/n936Bz7Pug">
              Join the Discord
            </ButtonAnchor>
          </div>
        </div>
      </section>

      <MarketingFooter showStartSection={false} />
    </div>
  );
}
